import {TheRaveReelView} from "../reels/TheRaveReelView";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Layers, TheRaveLayers} from "./TheRaveLayers";
import {TimelineMax, TweenMax, TimelineLite, TweenLite} from "gsap";
import {FontStyleConfig} from "../config/FontConfig";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {TheRave} from "../TheRave";
import {TheRaveHelper} from "../utils/TheRaveHelper";
import {TheRaveSound} from "../sound/TheRaveSound";

export enum glowAndStackedNamesEnum {
    DOWN,
    UP
}

export enum spotlightsNamesEnum {
    animation
}

export enum wildGlowNamesEnum {
    animation
}

export enum xwayGlowNamesEnum {
    animation
}

export enum DoubleXwaysAnimations {
    glow,
    stackedWild,
    spotlight,
    wildGlow,
    xwayGlow
}

export class XwaysEqView extends PIXI.Container {

    private _skipped:boolean = false;
    private _stackedSoundPlayedThisRound:boolean = false;
    private _stackedStartPlayedThisRound:boolean = false;
    private _layer:StageLayer;

    private _eqGlowDurations: number [] = []; // spine.state.tracks[0].endTime

    private _stackedWildDurations: number [] = [];

    private _spotlights: PIXI.spine.Spine [] = [];
    private _spotlightWraps: PIXI.Sprite [] = [];
    private _spotlightDurations: number [] = [];

    private _wildGlowBlends: PIXI.spine.Spine [] = [];
    private _wildGlowWraps: PIXI.Sprite [] = [];
    private _wildGlowDurations: number [] = [];

    private _xwayGlowBlends: PIXI.spine.Spine [][] = [
        [],
        [],
        [],
        [],
        []
    ];
    private _xwayGlowWraps: PIXI.Sprite [][] = [
        [],
        [],
        [],
        [],
        []
    ];

    private _symHeight:number;
    private _symWidth:number;


    private colContainers: PIXI.Container [] = [];
    private cellsPerColumn: PIXI.Sprite [][] = [
        [],
        [],
        [],
        [],
        []
    ];

    private numberBmps: PIXI.BitmapText [][] = [
        [],
        [],
        [],
        [],
        []
    ];

    private activeIterationAnimation: TimelineMax [] = [
        new TimelineMax(),
        new TimelineMax(),
        new TimelineMax(),
        new TimelineMax(),
        new TimelineMax()
    ];

    private fullWildBgAnimWraps: PIXI.Sprite [] = [
        new PIXI.Sprite(),
        new PIXI.Sprite(),
        new PIXI.Sprite(),
        new PIXI.Sprite(),
        new PIXI.Sprite()
    ];

    private fullWilds:PIXI.Sprite [] = [];

    constructor() {
        super();

        this._layer = TheRaveLayers.getLayer(Layers.FOREGROUND_DXW)!;

        this.init();
    }

    public set skipped(val:boolean) {
        this._skipped = val;
    }

    public set stackedSoundPlayed(val:boolean) {
        this._stackedSoundPlayedThisRound = val;
    }

    public set stackedStartPlayed(val:boolean) {
        this._stackedStartPlayedThisRound = val;
    }

    public get stackedStartPlayed() {
        return this._stackedStartPlayedThisRound;
    }

    private createSingleSpineOnSym(colId:number, symId:number, type:string): PIXI.spine.Spine | undefined {
        let spine:PIXI.spine.Spine | undefined;

        if(type === "eqXwayGlow") {

            const actualReel:number = (colId > 4)? colId -5 : colId;

            if(this._xwayGlowBlends[actualReel][symId]) {
                this._xwayGlowWraps[actualReel][symId].visible = true;
                this._xwayGlowBlends[actualReel][symId].visible = true;
                return this._xwayGlowBlends[actualReel][symId];
            }

            const wrapper:PIXI.Sprite = new PIXI.Sprite();
            spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("eqXwayGlow"));

            if(spine) {
                wrapper.addChild(spine);
                wrapper.x = 73;
                wrapper.y = 80 + (150 * symId);

                this._xwayGlowWraps[colId][symId] = wrapper;
                this._xwayGlowBlends[colId][symId] = spine;

                this.colContainers[colId].addChild(wrapper);
            }
        }

        return spine;
    }

    private createSingleSpine(colId:number, type:string): PIXI.spine.Spine | undefined {
        let spine:PIXI.spine.Spine | undefined;

        if(type === "wildGlow") {
            const wrapper:PIXI.Sprite = new PIXI.Sprite();
            spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("wildGlow"));

            if(spine) {
                wrapper.addChild(spine);
                wrapper.x = 73;
                wrapper.y = 230;
                wrapper.visible = false;

                //this._wildGlowWraps[colId].destroy();
                this._wildGlowWraps[colId] = wrapper;
                this._wildGlowBlends[colId] = spine;

                this.colContainers[colId].addChild(wrapper);
            }
        }
        else if(type === "spotlight") {
            const wrapper:PIXI.Sprite = new PIXI.Sprite();
            spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("xwaySpotlights"));
            if(spine) {
                wrapper.addChild(spine);
                wrapper.x = 73;
                wrapper.y = 230;
                wrapper.visible = false;

                this._spotlightWraps[colId] = wrapper;
                this._spotlights[colId] = spine;

                this.colContainers[colId].addChild(wrapper);
            }
        }

        return spine;
    }

    private createSpinesPerSym():void {

        [0,1,2,3,4].forEach((reelId) => {
                const wrapper:PIXI.Sprite = new PIXI.Sprite();
                const spine:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("wildGlow"));

                if(reelId === 0) {
                    this._wildGlowDurations = TheRaveHelper.spineAnimationHelper(spine, "WILD GLOW");
                }

                wrapper.addChild(spine);
                wrapper.x = 73;
                wrapper.y = 80; //+ (150 * symId);
                wrapper.visible = false;

                this._wildGlowBlends.push(spine);
                this._wildGlowWraps.push(wrapper);
                this.colContainers[reelId].addChild(wrapper);
        });

        [0,1,2,3,4].forEach((reelId) => {

            [0,1,2].forEach((symId) => {
                const wrapper:PIXI.Sprite = new PIXI.Sprite();
                const spine:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("eqXwayGlow"));
                wrapper.name = "xwayGlow";

                if(reelId === 0 && symId === 0) {
                    this._wildGlowDurations = TheRaveHelper.spineAnimationHelper(spine, "XWAY GLOW");
                }

                wrapper.addChild(spine);
                wrapper.x = 73;
                wrapper.y = 80 + (150 * symId);
                wrapper.visible = false;

                this._xwayGlowBlends[reelId].push(spine);
                this._xwayGlowWraps[reelId].push(wrapper);
                this.colContainers[reelId].addChild(wrapper);
            });
    });
}

private createXwaySpines():void {
    // spotlights
    [0,1,2,3,4].forEach((i) => {
        const wrapper:PIXI.Sprite = new PIXI.Sprite();
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("xwaySpotlights"));
        wrapper.name = "EQSpotlightWrapper";

        if(i === 0) {
            this._spotlightDurations = TheRaveHelper.spineAnimationHelper(spine, "EQ SPOTLIGHTS", false);
        }

        wrapper.addChild(spine);
        wrapper.x = 73;
        wrapper.y = 230;
        wrapper.visible = false;


        this._spotlights.push(spine);
        this._spotlightWraps.push(wrapper);
        this.colContainers[i].addChild(wrapper);
    });
}

private createNumbers(wrapperHeight:number):PIXI.BitmapText [] {
    const bmps:PIXI.BitmapText [] = [];

    ["x6", "x7", "x8", "x9", "x10", "x11"].forEach((txt) => {
        const bmpText = new PIXI.BitmapText(txt, FontStyleConfig.SYMBOL_MULTIPLIER);
        bmpText.name = txt;
        bmpText.y = wrapperHeight - bmpText.height;
        bmpText.x = 14.5;
        bmpText.letterSpacing = -8;
        bmpText.visible = true;
        bmps.push(bmpText);
    });
    return bmps;
}

init():void {

    this._symWidth = TheRaveReelView.SYMBOL_WIDTH;
    this._symHeight = TheRaveReelView.SYMBOL_HEIGHT;

    this.createEqAnimationPerReel();
    //this.tmpDebugHandler();

    this.resetNumbers();
    this.createSpinesPerSym();

    this.fullWildBgAnimWraps.forEach((spr, index) => {
        spr.name = "FullWildBgAnimWrapper";
    });
}

private playGlow(reelId:number, up:boolean = false, callback: () => void = () => {}):TimelineLite {
    const tl:TimelineLite = new TimelineLite();
    let spine:PIXI.spine.Spine | undefined = undefined;

    if(up) {
        tl.add([
            () => {
                spine = this.playSpine(DoubleXwaysAnimations.glow, reelId, glowAndStackedNamesEnum[glowAndStackedNamesEnum.UP], false);
            }
        ], 0);
        tl.add(() => {
            callback();
        }, this._eqGlowDurations[1]);
    }
    else {
        tl.add([
            () => {
                spine = this.playSpine(DoubleXwaysAnimations.glow, reelId, glowAndStackedNamesEnum[glowAndStackedNamesEnum.DOWN], false);
            }
        ], 0);
        tl.add(() => {
            callback();
        }, this._eqGlowDurations[0]);
    }

    return tl;
}

private playStackedWild(reelId:number, up:boolean = false, callback: () => void = () => {}):TimelineLite {
    const tl:TimelineLite = new TimelineLite();
    let spine:PIXI.spine.Spine | undefined = undefined;

    if(up) {
        tl.add([
            () => {
                spine = this.playSpine(DoubleXwaysAnimations.stackedWild, reelId, glowAndStackedNamesEnum[glowAndStackedNamesEnum.UP], false);
            }
        ], 0);
        tl.add(() => {
            callback();
        }, this._stackedWildDurations[1]);
    }
    else {
        tl.add([
            () => {
                spine = this.playSpine(DoubleXwaysAnimations.stackedWild, reelId, glowAndStackedNamesEnum[glowAndStackedNamesEnum.DOWN], false);
            }
        ]);
        tl.add(() => {
            callback();

        }, this._stackedWildDurations[0]);
    }

    return tl;
}

private playSpotlight(reelId:number, callback: () => void = () => {}):TimelineLite {
    const tl:TimelineLite = new TimelineLite();
    let spine:PIXI.spine.Spine | undefined = undefined;

    tl.add(() => {
        spine = this.playSpine(DoubleXwaysAnimations.spotlight, reelId, spotlightsNamesEnum[spotlightsNamesEnum.animation], false)
    });
    tl.add(() => {
        callback();
    }, this._spotlightDurations[0]);

    return tl;
}

private playWildGlow(reelId:number, callback: () => void = () => {}, loop:boolean = false):TimelineLite {
    const tl:TimelineLite = new TimelineLite();
    let spine:PIXI.spine.Spine | undefined = undefined;

    tl.add(() => {
        spine = this.playSpine(DoubleXwaysAnimations.wildGlow, reelId, wildGlowNamesEnum[wildGlowNamesEnum.animation], loop)
    });
    tl.add(() => {
        callback();
    }, this._wildGlowDurations[0]);

    return tl;
}

public playXwayGlow(reelId:number, callback: () => void = () => {}, loop:boolean = false, symId:number):TimelineLite {
    const tl:TimelineLite = new TimelineLite();
    let spine:PIXI.spine.Spine | undefined = undefined;
    const actualReelId:number = (reelId > 4)? reelId - 5 : reelId;

    tl.add(() => {
        this._xwayGlowBlends[actualReelId][symId].visible = true;
        this._xwayGlowWraps[actualReelId][symId].visible = true;
        spine = this.playSpine(DoubleXwaysAnimations.xwayGlow, reelId, xwayGlowNamesEnum[xwayGlowNamesEnum.animation], loop, symId)
    });

    return tl;
}

public playSpotlightAndGlow(reelId:number, up:boolean = false): TimelineLite {
    const tl:TimelineLite = new TimelineLite();

    tl.add([
        ()=>{
            if(!this._stackedSoundPlayedThisRound) {
                TheRaveSound.playSoundEffect("wildStackedExpand");
                this.stackedSoundPlayed = true;
                //console.log("EQ VIEW STACKED EXPAND SOUND");
            }
        },
        this.getAnimListPart("wildGlow", reelId, up),
        this.getAnimListPart("spotlight", reelId)
    ]);

    return tl;
}

private getAnimListPart(part: string, colId: number, up:boolean = false):TimelineLite {
    const tl:TimelineLite = new TimelineLite();

    tl.add(() => {this.colContainers[colId].visible = true});

    switch(part) {
        case "wildGlow":
            tl.add(this.playWildGlow(colId, () => {
            }));
            break;
        case "eqXwayGlow":
            break;
        case "glow":
            tl.add(this.playGlow(colId, up, () => {
            }));
            break;
        case "stacked":
            tl.add(this.playStackedWild(colId, up, () => {
            }));
            break;
        case "spotlight":
            tl.add(this.playSpotlight(colId, () => {
            }));
            break;
    }

    return tl;
}

public playSpine(animation: number, reelId:number, animName:string, loop:boolean = false, symId:number = 0): PIXI.spine.Spine | undefined {

    let spineRet:PIXI.spine.Spine | undefined = undefined;

    switch(animation) {

        case DoubleXwaysAnimations.xwayGlow:
            const actualReel:number = (reelId > 4)? reelId -5 : reelId;
            const spineXG: PIXI.spine.Spine | undefined = this.createSingleSpineOnSym(actualReel, symId, "eqXwayGlow");
            this._xwayGlowBlends[actualReel][symId].visible = true;
            this._xwayGlowWraps[actualReel][symId].visible = true;

            if(spineXG) {
                spineXG.state.setAnimation(0, animName, loop);
                spineRet = spineXG;
            }
            break;
        case DoubleXwaysAnimations.wildGlow:
            this.createSingleSpine(reelId, "wildGlow");
            const spineWG: PIXI.spine.Spine = this._wildGlowBlends[reelId];
            this._wildGlowWraps[reelId].visible = true;
            spineWG.state.setAnimation(0, animName, loop);

            spineRet = spineWG;
            break;
        case DoubleXwaysAnimations.glow:
            break;
        case DoubleXwaysAnimations.stackedWild:
            break;
        case DoubleXwaysAnimations.spotlight:
            this.createSingleSpine(reelId, "spotlight");
            const spine3: PIXI.spine.Spine = this._spotlights[reelId];
            this._spotlightWraps[reelId].visible = true;

            spine3.state.setAnimation(0, animName, loop);
            spineRet = spine3;
            break;
    }

    return spineRet || undefined;
}

private tmpDebugHandler(): void {
    const ref = this;
    document.addEventListener("keydown", function (e) {
        var keyCode = e.keyCode;
        //console.log("KeyCode: " + keyCode);

        switch (keyCode) {
            case 48:
                break; // 0
            case 49:
                ref.playSpotlightAndGlow(2, true);
                break; // 1
            case 50:
                ref.getAnimListPart("wildGlow", 1);
                break; // 2
            case 51:
                ref.playXwayGlow(2, () => {
                }, true, 1);
                break; // 3
            case 52:
                ref.getFullDoubleXwAnimList([3],[7]);
                //ref.createTraverseToResultCellAnimation(3, 9);
                break; // 4
            case 53:
                ref.getFullDoubleXwAnimList([4],[11]);
                //ref.createTraverseToResultCellAnimation(4, 10);
                break; // 5
        }
    }, false);
}

createEqAnimationPerReel():void {
    [0, 1, 2, 3, 4].forEach((rID) => {
        //if(rID === 0) {
            const cont: PIXI.Container = this.createEqSprite(rID);
            cont.y = TheRaveReelView.REEL_TOP + 38;
            cont.x = rID * TheRaveReelView.SYMBOL_WIDTH;
            this._layer.addChild(cont);
            cont.name = "EQViewContainer" + rID;
            //cont.visible = false;
            this.colContainers.push(cont);
        //}
    });
    this.createXwaySpines();
}

public createAndPlayFullWildBg(reelId:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const fullWildAnimation:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("450wildBlend"));
        const duration:number = TheRaveHelper.spineAnimationHelper(fullWildAnimation, "FULL WILD BG ANIMATION")[0];


        this.fullWildBgAnimWraps[reelId].visible = true;

        tl.add(() => {
            if(this.fullWildBgAnimWraps[reelId].children && this.fullWildBgAnimWraps[reelId].children.length > 0) {
                this.fullWildBgAnimWraps[reelId].removeChild(this.fullWildBgAnimWraps[reelId].children[0]);
            }
            this.fullWildBgAnimWraps[reelId].addChild(fullWildAnimation);
            this.fullWildBgAnimWraps[reelId].children[0].visible = true;
            fullWildAnimation.state.setAnimation(0, "animation", false);
        });
        tl.add(() => {
            //this.fullWildBgAnimWraps[reelId].visible = false;
            //this.fullWildBgAnimWraps[reelId].children[0].visible = false;
            //this.fullWildBgAnimWraps[reelId].removeChild(this.fullWildBgAnimWraps[reelId].children[0])
        }, duration)

        return tl;
}

private createEqSprite(colId:number):PIXI.Container {
    const wrapper:PIXI.Container = new PIXI.Container();
    const bgSprite:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
    const fullWild:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("dxWild"));

    const eqCells:PIXI.Sprite [] = [];
    const symWidth:number = TheRaveReelView.SYMBOL_WIDTH;
    const symHeight:number = TheRaveReelView.SYMBOL_HEIGHT;

    wrapper.name = "EqSpriteContainer";

    wrapper.width = TheRaveReelView.REEL_WIDTH;
    wrapper.height = TheRaveReelView.REEL_HEIGHT;

    bgSprite.tint = 0x000000;
    bgSprite.alpha = 0.8;
    bgSprite.width = symWidth - 8;
    bgSprite.height = TheRaveReelView.REEL_HEIGHT;
    bgSprite.x = 5;
    //wrapper.addChild(bgSprite);


    fullWild.alpha = 0;
    fullWild.x = 5;
    this.fullWilds.push(fullWild);
    wrapper.addChild(fullWild);
    wrapper.addChild(this.fullWildBgAnimWraps[colId]);
    this.fullWildBgAnimWraps[colId].x = 73;
    this.fullWildBgAnimWraps[colId].y = 230;

    const cellHeight:number = (wrapper.height / 11) - 4;
    const cellStartY:number = wrapper.height - (cellHeight + 8);

    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].forEach((cellID) => {
        let spr: PIXI.Sprite;

        if(cellID > -1 && cellID < 5) {
            spr = new PIXI.Sprite(ImgLoader.getImgTexture("green"));
        }
        else if(cellID >= 5 && cellID < 9) {
            spr = new PIXI.Sprite(ImgLoader.getImgTexture("yellow"));
        }
        else {
            spr = new PIXI.Sprite(ImgLoader.getImgTexture("red"));
        }

        spr.width = symWidth - 4;
        spr.height = cellHeight;
        spr.alpha = 0;

        spr.y = cellStartY - (cellID * (cellHeight + 2));
        spr.x = 2;
        wrapper.addChild(spr);

        this.cellsPerColumn[colId].push(spr);
    })

    // Add text bmps
    const bmps:PIXI.BitmapText [] = this.createNumbers(wrapper.height);
    bmps.forEach((txt) => {
        txt.visible = true;
        wrapper.addChild(txt);
        this.numberBmps[colId].push(txt);
    });

    const xWayExpander:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("dxWays"));
    xWayExpander.anchor.y = 0.5;
    xWayExpander.x = 5;
    xWayExpander.y =  TheRaveReelView.SYMBOL_HEIGHT * 1.5;
    xWayExpander.visible = false;

    return wrapper;
    }

    private createStopAnimation(colIndex:number):TimelineMax {
        const tl:TimelineMax = new TimelineMax();

        if(this.activeIterationAnimation[colIndex] != undefined && !this.activeIterationAnimation[colIndex].isActive()) {
            return new TimelineMax();
        }
        else {
            this.activeIterationAnimation[colIndex].pause(100);
        }

        return tl;
    }

    public resetAllXwayGlows():void {
        [0,1,2,3,4].forEach((colId, index) => {
            const tl:TimelineLite = new TimelineLite();
            // Add EQ cell animation

            this._xwayGlowBlends[colId].forEach((spine) => {
                spine.visible = false;
            });
            this._xwayGlowWraps[colId].forEach((sprite) => {
                sprite.visible = false;
            });
        })
    }


    public getFullDoubleXwAnimList(colIds:number [], symbolTotalSizes:number []): TimelineLite [] {
        const tlList:TimelineLite [] = [];


        // Add expand xWay animation

        // Add EQ cell animation
        colIds.forEach((colId, index) => {
            const tl:TimelineLite = new TimelineLite();
            // Add EQ cell animation

            this._xwayGlowBlends[colId].forEach((spine) => {
                spine.visible = false;
            });
            this._xwayGlowWraps[colId].forEach((sprite) => {
                sprite.visible = false;
            });
            tl.add(this.createAndPlayFullWildBg(colId));
            tl.add([
                this.playSpotlightAndGlow(colId, true),
                this.createTraverseToResultCellAnimation(colId, symbolTotalSizes[index]),
                () => TheRave.background.playShakeEffect()
            ]);
            tl.add(() => this.hideCells(colId, this.cellsPerColumn[colId]), "-=0.2");
            tl.add([
                //() => {this.colContainers[colId].visible = false},
                () => {
                    this.fullWilds[colId].alpha = 0;
                    //this.fullWilds[colId].visible = false;

                    [0,1,2,3,4].forEach((colId) => {
                        this.numberBmps[colId].forEach((spr) => {
                            spr.alpha = 0;
                        })
                    });
                }
            ], "+=0.4");
            tlList.push(tl);
        });

        return tlList;
    }

    public showWildSymAndSize(colId:number, symbolSize:number):TimelineMax {
        const tl:TimelineMax = new TimelineMax();
        let numberSprite:PIXI.BitmapText | undefined;

        //debugger;
        //console.log("XWAY DOUBLE, WILD AND SYM SIZE, Rell: " + colId + " SYMSIZE: " + symbolSize, this.numberBmps);
        this.numberBmps[colId].forEach((sprite:PIXI.BitmapText) => {
            //debugger;
            if(sprite.text === "x" + symbolSize){
                numberSprite = sprite;
            }
        });

        if(numberSprite !== undefined) {
            numberSprite.visible = true;
            tl.add([
                () => {
                //debugger;
                    numberSprite!.visible = true;
                    numberSprite!.alpha = 0;
                    if(!this._skipped) {
                        TheRaveSound.playSoundEffect("wildStackedMultiplier");
                    }
                }
                ,
                TweenLite.fromTo(numberSprite, 0.2, {
                    alpha: 0
                }, {
                    alpha: 1
                })
            ]);
        }

        return tl;
    }

    public createTraverseToResultCellAnimation(colId:number, toCell:number):TimelineMax {
        const tl:TimelineMax = new TimelineMax({
            paused: true
        });

        // furst pump to id 8
        /*
            - 7-11 final X
         */
        const cellsFirst:PIXI.Sprite [] = this.cellsPerColumn[colId].slice()//.slice(0, 8);
        const revCells:PIXI.Sprite [] = cellsFirst.slice().reverse();
        const cellsEnd:PIXI.Sprite [] = this.cellsPerColumn[colId].slice(2, toCell);

        const startRun: TimelineMax = new TimelineMax();
        const middleRun: TimelineMax = new TimelineMax();
        const endRun: TimelineMax = new TimelineMax();



        tl.add(() => {this.fullWilds[colId].alpha = 1});
        let num:number = 0.02;
        cellsFirst.forEach((cell, index) => {
            //if(index <= toCell) {
            num = this.getRandomNumberBetween(0.01, 0.045);
            startRun.add(TweenMax.fromTo(cell, num, {
                alpha: 0
            }, {
                alpha: 1
            }), "+=" + num.toString());
                //console.log("NUM: " + num);
            //}
        });
        tl.add(startRun);

        revCells.forEach((cell, cellIndex) => {
            if(cellIndex < 9) {
                num = this.getRandomNumberBetween(0.01, 0.045);
                middleRun.add(TweenMax.to(cell, num, {
                    alpha: 0
                }), "+=" + num.toString());
            }
        });
        tl.add(middleRun);

        cellsEnd.forEach((cell) => {
            num = this.getRandomNumberBetween(0.01, 0.045);
            endRun.add(TweenMax.to(cell, num, {
                alpha: 1
            }), "+=" + num.toString());
        });
        tl.add(endRun);
        tl.add(this.showWildSymAndSize(colId, toCell));

        tl.play(0);
        return tl;
    }

    private getRandomNumberBetween(min:number, max:number){
        return Math.random()*(max-min)+min;
    }

    public resetNumbers(onContinueCallBack: () => void = () => {}): void {
        this.colContainers.forEach((container) => {
            container.children.forEach((sprite) => {
                if(sprite.name && sprite.name.indexOf("x") > -1) {
                    //console.log("HIT ON SPRTE: " + sprite.name);
                    sprite.visible = false;
                }
            })
        });
    }


    private hideCells(colId:number, cells:PIXI.Sprite []):void {
        cells.forEach((cell) => {
            cell.alpha = 0;
        })
    }

    private createIterateCellAnimation(colId:number, cells:PIXI.Sprite [], repeat:number):TimelineMax {
        const tl:TimelineMax = new TimelineMax({repeat: repeat, yoyo: false});

        const revCells: PIXI.Sprite [] = cells.slice().reverse();

        tl.add(() => {this.colContainers[colId].visible = true});
        cells.forEach((cell, cellIndex) => {
            tl.add(TweenMax.fromTo(cell, 0.02, {
                alpha: 0
            }, {
                alpha: 1
            }), "+=0.02");
        });
        revCells.forEach((cell, cellIndex) => {
            tl.add(TweenMax.to(cell, 0.02, {
                alpha: 0
            }), "+=0.02");
        });

        return tl;
    }

}